import { render, staticRenderFns } from "./ElasticChatStartups.vue?vue&type=template&id=65454c18&scoped=true&"
import script from "./ElasticChatStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./ElasticChatStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65454c18",
  null
  
)

export default component.exports